"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var reservationLabelStyles = styles_1.makeStyles(function (_a) {
    var palette = _a.palette, typography = _a.typography;
    return ({
        container: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '15px',
        },
        tooltipContent: {
            fontFamily: typography.fontFamily,
            fontSize: typography.fontXS,
            whiteSpace: 'pre-line',
            marginBottom: '30px',
            '& a': {
                fontWeight: 700,
                textDecoration: 'none',
                color: palette.primary.main,
            },
        },
        tooltipCloseIcon: {
            position: 'absolute',
            right: 10,
            top: 10,
            color: palette.primary.main,
            fontSize: typography.fontXL,
            cursor: 'pointer',
        },
        label: {
            fontFamily: typography.fontFamily,
            color: palette.text.primary,
            fontSize: typography.fontMD,
        },
        boldLabel: {
            fontFamily: typography.fontFamily2,
            color: palette.text.primary,
        },
        reservationAmount: {
            borderBottom: "1px solid " + palette.primaryDisabled.main,
        },
        outStandingBalance: {
            padding: '5px 0',
            borderBottom: "1px solid " + palette.primaryDisabled.main,
        },
        amount: {
            fontFamily: typography.fontFamily2,
            color: palette.primary.main,
            fontSize: typography.fontLG,
            marginRight: '15px',
        },
    });
}, { name: 'Summary_ReservationLabelTooltip' });
exports.default = reservationLabelStyles;
